import styled from "styled-components";

export const BillingBottom = styled.div`
  display: flex;
  margin-top: 1.5rem;
  padding-top: 0;
  padding-bottom: 0.25rem;
  width: 100%;
  margin-bottom: 0;
  @media (max-width: 1023px) {
    width: 100%;
  }
  // @media (max-width: 1279px) {
  //   flex-direction: column;
  // }
  @media (min-width: 1024px) {
    padding: 0px;
    margin: 0 !important;
  }
`;

export const LeftDiv = styled.div`
  width: 55%;
  display: flex;
  align-items: center;
`;

export const RightDiv = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  margin-left: auto;
  justify-content: flex-end;
  @media (min-width: 1024px) {
    padding-top: 0px;
    margin-top: 24px;
  }
`;

export const GotoLabel = styled.div`
  display: inline-block;
  width: 12%;
  padding-top: 1;
  font-size: 12px;
`;
export const GotoInput = styled.div`
  display: flex;
  width: 120px;
  align-items: center;
  padding-top: 0rem;
  padding-left: 0.25rem;
  padding-right: 3rem;
  > div {
    width: 40px;
  }
`;
export const PageCountBox = styled.div`
  display: inline-block;
  padding-left: 0.75rem;
`;
